import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as ls from "./_csLcl";
import { a } from "./_csAbt";

import * as BtnC from './_cccBtnC';
import * as TblC from "./_ccmTblC";
import * as TextC from "./_ccbTextC";
import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';

import * as ica from 'src/ica';
import * as ihd from 'src/ihd';

import * as _cv_60 from './_cv_60___Mz';

let $_60z = _cv_60.itl_60z();

import * as BtnCttC from './_ccmBtnCttC';

export const B = (pz: ht.btnCttCz) => {
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _60z = await _cv_60.save_60rDzAsync({
            ... pz,
            _60z: $_60z,
          });
          return {
            _60r_fst: _60z._60rz._fst,
          };
        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = ls.frcUdt();

  React.useEffect(() => {

    f.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        _cv_60.crt_60z()
        .then((_dz: ht.dz) => {
          $_60z = _dz;
        })
      ],
      udtAsync: () => [
        _cv_60.load_60rDzAsync({
          _60r_fst: pz.sPz.crt._60r_fst
        })
        .then((_dz: ht.dz) => {
          $_60z = _dz;
        })
      ],
    });

  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._60r_fst
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  const _hdrs = [] as ht.ls;

  _hdrs.push({
    cellCs: [
      {
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            ... _abtz.cldz.hdrCz.textCz,
            textz: {
              pfx: '祝日',
              stlz: a(`tc/${pz.cz.ccd}7`)
            }
          })
        ]
      },
    ],
  });

  const _bdys = [] as ht.ls;
  $_60z._601s
  .filter( ( _601z:ht.dz ) => _601z._dlt != 1 )
  .map( ( _601z:ht.dz ) => {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(IptC.S, {
              key: -10,
              cz: {
                bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                iptType: 'dtm',
                vle: _601z._icn ?? '',
                onChg: ( _dtm: ht.s ) => {
                  _601z._icn = _dtm;
                }
              }
            })
          ]
        },
        {
          boxStlz: a('dw/10 f/n'),
          oClds: [
            hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnDltCz,
              boxStlz: a(`sc/${pz.cz.ccd}5`),
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  _601z._dlt = 1;
                  _frcUdt();
                },
              }
            })
            : null,
          ]
        },
      ],
    });
  });
  
  if ( hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ) {
    _bdys.push({
      cellCs: [
        {
          oClds: [
            cr.c(BtnC.N, {
              key: -10,
              ... _abtz.cldz.bdyCz.btnAddCz,
              boxStlz: a(`sc/${pz.cz.ccd}5`),
              bfrIconCz: {},
              lblCz: {},
              pslPtyz: {
                onPress: () => {
                  $_60z._601s.push(ihd.i(`_601`));
                  _frcUdt();
                },
              }
            })
          ]
        },
      ],
    });
  }

  //hf.l(`_cv_60b 157: ${hf.s($_60z)}`);
  return (
    cr.c(BoxC.N, {
      key: '_60b.Root',
      boxStlz: a('dw/f fd/csc'),
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'nolineCmnz',
          boxStlz: a('dwx/60 mb/2 mh/a'),
          lineCs: [
            {
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        textz: {
                          pfx: `対象年：`,
                          stlz: a(`tc/${pz.cz.ccd}7`),
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: $_60z._60rz._icn ?? '',
                              onChg: (_s: ht.s) => {
                                $_60z._60rz._icn = _s;
                              }
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        }),

        cr.c(TblC.N, {
          key: -20,
          ... _abtz.cldz.tblCz,
          srlCz: {
            srlStlz: {
              otrz: a('dwx/50'),
            }
          },
          hdrCz: {
            boxStlz: a(`bc/${pz.cz.ccd}7`),
            lineCs: _hdrs
          },
          bdyCz: {
            boxStlz: a(`bc/${pz.cz.ccd}7`),
            lineCs: _bdys
          }
        })

      ]
    })
  );
};

